import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import GlobalContext from 'agency/digital_renderer/utils/context'
import VideoPlayer from 'agency/digital_renderer/components/VideoPlayer'

const Video = (props) => {
  const { data: { value }, options: { videoProvider } } = props

  const defaultContext = useContext(GlobalContext)
  const { dataSource } = defaultContext

  if (videoProvider && value){
    return (
      <VideoPlayer customVideo={{ id: value, provider: videoProvider }} />
    )
  }

  return (
    <VideoPlayer dataSource={dataSource} />
  )
}

Video.propTypes = {
  data: PropTypes.object,
  options: PropTypes.object,
}

Video.defaultProps = {
  data: {},
  options: {},
}

export default Video
